import React from 'react';

export default function AddIcon() {
  return (
    <svg className="text-skin-text" height="28" width="28" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" transform="translate(4 4)">
        <path d="m12.5 10.5v-8c0-1.1045695-.8954305-2-2-2h-8c-1.1045695 0-2 .8954305-2 2v8c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2z" />
        <path d="m6.5 3.5v6.056" />
        <path d="m6.5 3.5v6" transform="matrix(0 1 -1 0 13 0)" />
      </g>
    </svg>
  );
}
